<template>
	<div>
		<div class="signing-top">
			<div class="top">

				<div class="content">
					<h1>{{$t('review-sign.contract.headline') }}</h1>
					<p>{{ getSigningPropertyAddress }}</p>
				</div>
                <router-link :to="{name: 'contracts'}"><button class="purple">{{ $t('contract-signed.go-to-overview.button') }}</button></router-link>
    			</div>
			<div class="progress-bar">
				<div class="content">
					<div class="col done">
						<div class="dot">
							<svg xmlns="http://www.w3.org/2000/svg"  width="9.895" height="7.38" viewBox="0 0 19.79 14.76">
							  <path class="fill-white" d="M1330.31,1086.51l-10.8,10.8a2.256,2.256,0,0,1-3.02,0l-4.8-4.8a1.994,1.994,0,1,1,2.82-2.82l3.49,3.48,9.49-9.48A1.994,1.994,0,1,1,1330.31,1086.51Z" transform="translate(-1311.12 -1083.12)"/>
							</svg>
						</div>
						<p>{{$t('review-sign.steps.info')}}</p>
					</div>
					<div class="col done">
						<div class="dot">
							<svg xmlns="http://www.w3.org/2000/svg"  width="9.895" height="7.38" viewBox="0 0 19.79 14.76">
							  <path class="fill-white" d="M1330.31,1086.51l-10.8,10.8a2.256,2.256,0,0,1-3.02,0l-4.8-4.8a1.994,1.994,0,1,1,2.82-2.82l3.49,3.48,9.49-9.48A1.994,1.994,0,1,1,1330.31,1086.51Z" transform="translate(-1311.12 -1083.12)"/>
							</svg>
						</div>
						<p>{{$t('review-sign.steps.review')}}</p>
					</div>
                    <div class="col done" v-if="isPowerSupplyEnabled">
                        <div class="dot">
                            <svg xmlns="http://www.w3.org/2000/svg"  width="9.895" height="7.38" viewBox="0 0 19.79 14.76">
                                <path class="fill-white" d="M1330.31,1086.51l-10.8,10.8a2.256,2.256,0,0,1-3.02,0l-4.8-4.8a1.994,1.994,0,1,1,2.82-2.82l3.49,3.48,9.49-9.48A1.994,1.994,0,1,1,1330.31,1086.51Z" transform="translate(-1311.12 -1083.12)"/>
                            </svg>
                        </div>
                        <p>{{$t('review-sign.steps.electricity') }}</p>
                    </div>
					<div class="col done">
						<div class="dot">
							<svg xmlns="http://www.w3.org/2000/svg"  width="9.895" height="7.38" viewBox="0 0 19.79 14.76">
							  <path class="fill-white" d="M1330.31,1086.51l-10.8,10.8a2.256,2.256,0,0,1-3.02,0l-4.8-4.8a1.994,1.994,0,1,1,2.82-2.82l3.49,3.48,9.49-9.48A1.994,1.994,0,1,1,1330.31,1086.51Z" transform="translate(-1311.12 -1083.12)"/>
							</svg>
						</div>
						<p>{{$t('review-sign.steps.sign')}}</p>
					</div>
				</div>
			</div>
		</div>
		<div class="signing-content success">
			<div class="content-box small">
				<div class="container">
					<div class="icon">
						<simple-svg
							:filepath="'images/SVG/Success.svg'"
							:height="'175px'"
							:width="'175px'"
						/>
					</div>
					<h1>{{ $t('contract-signed.headline.label') }}</h1>
					<p class="text">{{ $t('contract-signed.text.label') }}</p>
					<router-link :to="{name: 'contracts'}"><button class="purple">{{ $t('contract-signed.go-to-overview.button') }}</button></router-link>
				</div>
			</div>
		</div>
	</div>
</template>
<script>


    import {store} from "../../store";
    import {mapGetters} from "vuex";

    export default {
    	computed: {
			...mapGetters([
            	'getToken',
            	'getSigningPropertyAddress',
                'isPowerSupplyEnabled'
        	])
		},
    }

</script>
